// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"61":"e0ef21a3","168":"d6b843cc","462":"f24809eb","712":"c721562f","717":"1f54fa80","827":"884f9792","843":"36aee183","904":"f3c80195","981":"4c5c692f"}[chunkId] + ".js";
};